import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

export const FooterText = styled(Typography)(({ theme }) => ({
  ...theme.body,
  marginTop: theme.spacing(4),
  marginBottom: theme.spacing(4),
  fontStyle: "italic",
  [theme.breakpoints.down("md")]: {
    fontSize: theme.spacing(2),
  },
  [theme.breakpoints.down("sm")]: {
    fontSize: "14px",
  },
}));
